import '/modules/edid/css/ui/edidTableContainer.css';
import '/modules/edid/css/ui/edidTableContainer.responsive.css';
import '/modules/edid/css/ui/edidTableContainer.mobile.css';
import {AbstractContainer} from "../../common/timeseries/AbstractContainer";
import {
    AbstractRowAction,
    ColumnTypeEnum,
    DateTableFilter,
    DropdownTableFilter,
    ServerPagedTableWithFilters,
    TableColumn,
    TextTableFilter
} from "../../common/ui/TableWithFilters";
import {EDIDSystemEnum} from "../enum/EDIDSystem";
import {EDIDSeverityEnum} from "../enum/EDIDSeverity";
import {isNumber, nnTrim, toNumber} from "../../common/util";

class EdidTableContainer extends AbstractContainer {
    getClassName() {
        return "EdidTableContainer";
    }

    /**
     *
     * @param id {string} An HTML id for this selector container
     * @param serviceUrl {string} The service url to get data for the table
     * @param regionsServiceUrl {string} The service url to get data for the regions filters
     * @param byIdServiceUrl {string} The service url to get record by id
     * @param contextInfo {string} Context info to display above the table filters
     */
    constructor(id, serviceUrl, regionsServiceUrl, byIdServiceUrl, contextInfo) {
        super(id);
        this.expanded = true;
        this.serviceUrl = serviceUrl;
        this.regionsServiceUrl = regionsServiceUrl;
        this.byIdServiceUrl = byIdServiceUrl;
        this.contextInfo = contextInfo;
    }

    getContainerElement() {
        const self = this;
        const content = $(
            '<div class="drought-search-table container expanded">' +
            '   <header class="header">' +
            '   </header>' +
            '   <section class="body">' +
            '   </section>' +
            '</div>'
        );

        const urlSearchParams = new URLSearchParams(window.location.search);
        const nuts3Code = nnTrim(urlSearchParams.get('nuts3Code'));
        const nuts2Code = nnTrim(urlSearchParams.get('nuts2Code'));
        const nuts1Code = nnTrim(urlSearchParams.get('nuts1Code'));
        const countryCode = nnTrim(urlSearchParams.get('countryCode'));

        const openRecord = (element) => {
            window.open(window.location.href.split('?')[0] + '?id=' + element.id+'&fromTable', '_self');
        }
        this.fetcherFactory.getFetcher(this.regionsServiceUrl)
            .success(regions=>{
                class ViewRecordAction extends AbstractRowAction {
                    getButtonElement() {
                        return $('<button>').attr('type','button').addClass('open-record action');
                    }

                    onClick(element) {
                        self.logStat('OPEN_RECORD_FROM_TABLE_ROW {'+element.id+'}', true);
                        openRecord(element);
                    }

                    getName() {
                        return tumbo.translator.translate('edid.search.record.open');
                    }
                }

                const tableColumns = [
                    new TableColumn('id', ColumnTypeEnum.STRING, "edid.search.record.record", 220, true, false, (value, elem, row, td) => {
                        const sev = EDIDSeverityEnum.getForCode(elem[colCodes.indexOf('severity')]);
                        return '<div>' + elem[colCodes.indexOf('id')] + ' - ' + EDIDSystemEnum.getForCode(elem[colCodes.indexOf('system')]).getLocalizedName() + '</div><br/>' +
                            '<div><span class="color" style="background-color: ' + sev.getColour() + '"></span> ' + sev.getLocalizedName() + '</div>';
                    }).setMultiline(true),
                    new TableColumn('severity', ColumnTypeEnum.STRING, undefined, undefined, false),
                    new TableColumn('system', ColumnTypeEnum.STRING, undefined, undefined, false),
                    new TableColumn('description', ColumnTypeEnum.STRING, 'edid.search.record.description',undefined, true, false),
                    new TableColumn('start', ColumnTypeEnum.DATE, 'edid.search.record.filter.from', 90, true, false),
                    new TableColumn('end_', ColumnTypeEnum.DATE, 'edid.search.record.filter.until', 90, true, false)
                ];
                const colCodes = tableColumns.map(c => c.getCode());

                regions = regions.map(r =>{
                    r.level = Number(r.level);
                    return r;
                }).sort((a, b) => a.name.localeCompare(b.name));
                const regionsForFilters = {
                    countries: regions.filter(r => r.level === 0),
                    nuts1: regions.filter(r => r.level === 1),
                    nuts2: regions.filter(r => r.level === 2),
                    nuts3: regions.filter(r => r.level === 3 && !!r.nuts2_code),
                };
                const countryFilter = new DropdownTableFilter('countryCodes', 'edid.search.record.filter.country', false,
                    regionsForFilters.countries.map(c => c.code), regionsForFilters.countries.map(c => '#' + c.name));
                const nuts1Filter = new DropdownTableFilter('nuts1Codes', 'edid.search.record.filter.nuts1', false,
                    regionsForFilters.nuts1.map(n => n.code), regionsForFilters.nuts1.map(n => '#' + n.name), regionsForFilters.nuts1.map(n => n.country_code), countryFilter);
                const nuts2Filter = new DropdownTableFilter('nuts2Codes', 'edid.search.record.filter.nuts2', false,
                    regionsForFilters.nuts2.map(n => n.code), regionsForFilters.nuts2.map(n => '#' + n.name), regionsForFilters.nuts2.map(n => n.nuts1_code), nuts1Filter);
                const nuts3Filter = new DropdownTableFilter('nuts3Codes', 'edid.search.record.filter.nuts3', false,
                    regionsForFilters.nuts3.map(n => n.code), regionsForFilters.nuts3.map(n => '#' + n.name), regionsForFilters.nuts3.map(n => n.nuts2_code), nuts2Filter);
                const textTableFilter = new TextTableFilter('description', 'edid.search.record.description').onChange((value)=>{
                    const v = toNumber(nnTrim(value));
                    if(isNumber(v)){
                        this.fetcherFactory.getFetcher(this.byIdServiceUrl.format([v]))
                            .success(record=>{
                                if(record && record.id) {
                                    self.logStat('OPEN_RECORD_FROM_TABLE_FILTER {'+record.id+'}', true);
                                    openRecord(record);
                                }
                            }).fetch();
                    }
                });
                if(countryCode)
                    countryFilter.setValue(countryCode);
                if(nuts1Code)
                    nuts1Filter.setValue(nuts1Code);
                if(nuts2Code)
                    nuts2Filter.setValue(nuts2Code);
                if(nuts3Code)
                    nuts3Filter.setValue(nuts3Code);
                const tableFilters = [
                    textTableFilter,
                    new DropdownTableFilter('system', 'edid.search.record.sector', false,
                        EDIDSystemEnum.getPossibleCodes().map(c => c + ""), EDIDSystemEnum.getPossibleCodes().map(c => EDIDSystemEnum.getForCode(c).getLocalizationKey())),
                    new DropdownTableFilter('severity', 'edid.search.record.severity', false,
                        EDIDSeverityEnum.getPossibleCodes().map(c => c + ""), EDIDSeverityEnum.getPossibleCodes().map(c => EDIDSeverityEnum.getForCode(c).getLocalizationKey())),
                    new DateTableFilter('start', 'edid.search.record.start').setApplyOnChange(false),
                    new DateTableFilter('end', 'edid.search.record.end').setApplyOnChange(false),
                    countryFilter,
                    nuts1Filter,
                    nuts2Filter,
                    nuts3Filter
                ];

                const rowActions = [
                    new ViewRecordAction()
                ];
                this.table = new ServerPagedTableWithFilters('search_table', tableColumns, tableFilters, undefined, rowActions, (reqData, callback) => {
                    const params = reqData.getRequestParams();
                    const paramsStr = Object.keys(params).map(paramName => paramName + '=' + encodeURIComponent(params[paramName])).join('&');
                    this.fetcherFactory.getFetcher(this.serviceUrl + '?' + paramsStr)
                        .success(data=>callback(data.map(d => tableColumns.map(c => d[c.getCode()]))))
                        .fetch();
                }, 50);
                const tableElement = this.table.getUIElement();
                if(this.contextInfo){
                    tableElement.prepend($('<div>').addClass('context').html(this.contextInfo))
                }
                $('.body', content).append(tableElement);
                this.enableObservationUnderUIElement();

            }).fetch();
        return content;
    }

    isCollapsible() {
        return false;
    }
}

export {EdidTableContainer}